import React from 'react'
import Button from '../../../common/button/Button'
import TinyProfiles from '../../../common/profile/TinyProfiles'
import { useParams, useNavigate } from 'react-router-dom'
import { getLDGroupLabel } from '../ReportingGroup/utils'
import { useGroupDashboardContext } from '../GroupDashboardContext'

const ReportingGroups = ({ teamData }) => {

    const { groups, canManage } = teamData
    const { filtersData } = useGroupDashboardContext()
    
    const handleViewGroup = (group_id) => {
        //useNavigate here
        console.log({
            "test": group_id 
        })
    }

    const ldGroupLabel = getLDGroupLabel( teamData )

    const params = useParams()
    const navigate = useNavigate()
    const root = `/organization/${params.team_id}`

    const handleManageGroups = ( value ) => {
      navigate(`${root}/${value}`)
    }
  
    return (
        <>
          <div className='msync-reporting-groups'>
            {
              Object.keys( groups ).length > 0 ?
              groups.map((group, key) => {
                  return (
                      <div className='msync-reporting-group' key={key}>
                        <div className="msync-reporting-group-container">
                          <div className="msync-members-container">
                            <h5> {group.group_name} </h5>
                            { 
                              group.group_excerpt && group.group_excerpt !== '' 
                              && <p>{group.group_excerpt}</p>
                            }
                            <div className="msync-members-tiny-profiles">
                              <div className="msync-members-tiny-profile">
                              { 
                                  group.group_users.length === 0
                                  ? <h6>No Members</h6>
                                  : <> 
                                      <h6>Members</h6>
                                      <TinyProfiles users={group.group_users} />
                                  </>
                              }
                              </div>
                              <div className="msync-members-tiny-profile">
                              {
                                  group.group_leaders.length === 0
                                  ? <h6>No Leaders</h6>
                                  : <>
                                      <h6>Leaders</h6>
                                      <TinyProfiles users={group.group_leaders} />
                                  </>
                              }
                                  
                              </div>
                            </div>
                          </div>
                          <div className='msync-report-group-details'>
                            {/* This is replaced by Soft Launch Adjustment */}
                            {/* <Button 
                                className="msync-outline-primary-btn"
                                name="View Group"
                                onClick={()=>handleViewGroup(group.group_id)}
                            /> */}
                            <a 
                            type='submit'
                            href={group.group_url}
                            className="msync-btn msync-outline-primary-btn">View { ldGroupLabel }</a>
                          </div>
                        </div>
                      </div>
                  )
              })  : (
                <p>{ filtersData.home?.no_associated_groups_label }</p>
              )
            }
          </div>
          {
            canManage &&
            <div className="msync-groups-buttons">
                <Button
                    className="msync-outline-primary-btn"
                    name="View Report"
                    onClick={ () => handleManageGroups('reporting-group') }
                />
              {/* This is removed by Soft Launch Adjustment
                <Button
                  name="Add Reporting Group"
              /> */}
            </div>
          }
        </>
    )
}

export default ReportingGroups
